<template>
    <div class="d-flex justify-center align-center w-full">

        <v-progress-circular
                v-if="isLoading"
                :active="true"
                color="primary"
                indeterminate
        ></v-progress-circular>

        <template v-else>
            <slot></slot>
        </template>

    </div>
</template>

<script>
export default {
    props: {
        isLoading: {
            type: Boolean,
            required: true,
        }
    }
}
</script>
